export default function timestamp(): string {
    return String(Date.now());
}
